import { getRedirectUri } from "../auths/storage";
import uuid from 'uuid/v4';

export var USER_LOGIN_STARTED = 'auths/loginStarted';
export var USER_LOGGED_IN = "auths/loggedIn";
export var USER_LOGGED_OUT = 'auths/loggedOut';

export var logIn = function logIn(token, expires_in) {
    return function (dispatch) {
        dispatch({ type: USER_LOGIN_STARTED });
        localStorage.setItem('kit.access_token', token);

        var futureRefresh = setTimeout(function () {
            dispatch(refreshToken());
        }, expires_in * 1000 - 60000);

        dispatch(loggedIn(futureRefresh));
    };
};

export var refreshToken = function refreshToken() {
    return function (dispatch) {
        dispatch({ type: USER_LOGIN_STARTED });
        var data = new URLSearchParams();
        data.append('grant_type', 'refresh_token');
        data.append('redirect_uri', getRedirectUri());

        fetch(process.env.REACT_APP_API_GATEWAY + '/auths/oauth2/token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Correlation-Id': uuid()
            },
            credentials: 'include',
            body: data
        }).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error(response.statusText);
            }
        }).then(function (data) {
            dispatch(logIn(data.access_token, data.expires_in));
        }).catch(function (error) {
            console.log(error);
            dispatch(logOut());
        });
    };
};

export var logOut = function logOut() {
    return function (dispatch) {
        localStorage.removeItem('kit.access_token');
        localStorage.removeItem('kit.expires');
        dispatch({
            type: USER_LOGGED_OUT
        });
    };
};

var loggedIn = function loggedIn(futureRefresh) {
    return {
        type: USER_LOGGED_IN,
        futureRefresh: futureRefresh
    };
};